import React from "react";
import { FormControl, Select, InputLabel, OutlinedInput } from "@mui/material";
import "../styles/TemplateSelector.css";

const TemplateSelector = ({
  selectedTemplate,
  handleSelect,
  templates = []
}) => {
  const groupedTemplates = templates.reduce((acc, template) => {
    const owner = template.owner || "Other";
    if (!acc[owner]) {
      acc[owner] = [];
    }
    acc[owner].push(template);
    return acc;
  }, {});

  return (
    <div className="sticky-selector-container">

      <FormControl style={{ width: "100%" }}>
        <InputLabel
          htmlFor="grouped-native-select"
          sx={{ fontSize: { xs: '0.8rem', md: '0.95rem' } }}
        >
          Select a Template
        </InputLabel>
        <Select
          native
          defaultValue=""
          id="grouped-native-select"
          label="Grouping"
          value={selectedTemplate}
          onChange={handleSelect}
          sx={{
            fontSize: { xs: '0.8rem', md: '0.95rem' },
            '& .MuiSelect-select': {
              padding: { xs: '10px 12px', md: '12px 16px' },
            }
          }}
          input={
            <OutlinedInput label="Select a Template" />
          }
        >
          <option aria-label="None" value="" />
          {Object.entries(groupedTemplates).map(([owner, ownerTemplates]) => (
            <optgroup
              key={owner}
              label={owner}
              className="responsive-optgroup"
            >
              {ownerTemplates.map((template) => {
                const templateValue = `${owner}|${template.name}`;
                return (
                  <option
                    key={templateValue}
                    value={templateValue}
                    className="responsive-option"
                  >
                    {template.name}
                  </option>
                );
              })}
            </optgroup>
          ))}
        </Select>
      </FormControl>

    </div>
  );
};

export default TemplateSelector;